import script from "./homeSearchScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./homeSearchScreen.vue?vue&type=script&setup=true&lang=js"

import "./homeSearchScreen.vue?vue&type=style&index=0&id=684fa6c4&lang=less"

const __exports__ = script;

export default __exports__